import { Aurora } from "@/components/Aurora";

export const KeyNumbers = ({ product }) => {
  if (!product.keyNumbers) return null;
  return (
    <section
      data-testid="key-numbers-strip"
      className="relative bg-[#0B132B] text-white overflow-hidden border-y border-white/5"
    >
      <Aurora intensity="intense" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-12 md:py-20">
        <p
          data-reveal
          className="text-xs sm:text-sm tracking-[0.25em] uppercase text-[#29ABE2] font-semibold mb-7 md:mb-12"
        >
          {product.tag} · By the numbers
        </p>
        <div className="grid grid-cols-3 gap-3 sm:gap-6 md:divide-x divide-white/10">
          {product.keyNumbers.map((k, i) => (
            <div
              key={i}
              data-reveal
              data-reveal-delay={i * 0.08}
              className="md:px-8 first:md:pl-0 last:md:pr-0 min-w-0"
            >
              <div className="font-heading font-black text-2xl sm:text-5xl lg:text-7xl tracking-tighter leading-[0.95] text-gradient-breeze break-words">
                {k.value}
              </div>
              <p className="mt-2 md:mt-4 text-xs sm:text-base text-white/70 font-light leading-snug">
                {k.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
